import anaConsts from 'analytics/constants';

export const EVENTS = {
    LANDING: 'superchat_landing',
    FLYOUT_OPEN: 'superchat_flyout_open',
    MENU_TOGGLE: 'superchat_menu_toggle',
    EXIT: 'superchat_exit',

    PROMPT_CLICK: 'superchat_prompt_click',
    FOLLOW_UP_CLICK: 'superchat_follow_up_click',

    ADD_TO_BASKET: 'superchat_add_to_basket',
    ADD_TO_LOVES: 'superchat_add_to_loves',
    REMOVE_FROM_LOVES: 'superchat_remove_from_loves',

    FEEDBACK_OPEN: 'superchat_feedback_open',
    FEEDBACK_SUBMIT: 'superchat_feedback_submit',

    VIEWABLE_IMPRESSION: 'superchat_viewable_impression',

    WELCOME_MAT_IMPRESSION: 'superchat_welcome_mat_impression',
    WELCOME_MAT_CATEGORY_VIEW: 'superchat_welcome_mat_category_view',

    SIGN_IN_CTA_CLICK: 'superchat_sign_in_cta_click'
};

export const EVENT_NAMES = {
    PROMPT_CLICK: 'superchat prompt click',
    FOLLOW_UP_CLICK: 'superchat follow up click',
    VIEWABLE_IMPRESSION: 'superchat viewable impression',

    WELCOME_MAT_IMPRESSION: 'superchat welcome mat impression',
    WELCOME_MAT_CATEGORY_VIEW: 'superchat welcome mat category view',

    SIGN_IN_CTA_CLICK: 'superchat sign in cta click'
};

export const SOT_FIELDS = {
    PRODUCT_ID: 'sotV15',
    CATEGORY_ID: 'sotV08',
    SEARCH_TERM: 'sotV104',
    CATEGORY_SEO_NAME: 'sotV163',
    DELAY_THRESHOLD: 'sotV219',
    COMPONENT_TYPE: 'sotV312',
    PRIMARY_TEXT: 'sotV402',
    MESSAGE_ID: 'sotV403',
    PREVIOUS_MESSAGE_ID: 'sotV404',
    REFERRER: 'sotV425'
};

export const PAGE_TYPES = {
    PRODUCT: 'product',
    CATEGORY: 'category',
    SEARCH: 'search',
    UNKNOWN: 'unknown'
};

export const SUPERCHAT_PAGE = {
    PAGE_NAME: 'superchat:landing',
    PAGE_TYPE: 'superchat',
    PAGE_DETAIL: 'superchat:landing'
};

export const NAV_SOURCES = {
    HEADER: 'header',
    BOTTOM_NAV: 'bottomNav'
};

export const ENTRY_POINTS = {
    PDP: 'PDP',
    SRP: 'SRP',
    PLP: 'PLP'
};

export const SUPER_CHAT = anaConsts.SUPER_CHAT;

export const ANALYTICS_EVENTS = anaConsts;
